(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["metaobject-pages-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function applyMetaobjectFilters(root) {
    if (!root) return;

    var params = new URLSearchParams(window.location.search);
    var typeFilter = handleize(params.get('type') || root.dataset.activeType || '');
    var enableValidity = root.getAttribute('data-enable-validity') === 'true';
    var validityDays = parseInt(root.getAttribute('data-validity-days') || '365', 10);
    if (isNaN(validityDays) || validityDays < 0) {
      validityDays = 365;
    }

    function parseLocalDate(isoDate) {
      var parts = String(isoDate || '').split('-');
      if (parts.length !== 3) return null;
      var year = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10) - 1;
      var day = parseInt(parts[2], 10);
      if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
      return new Date(year, month, day);
    }

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var visibleCount = 0;
    root.querySelectorAll('.metaobject-page-item[data-metaobject-entry]').forEach(function (item) {
      var visible = true;
      var itemType = handleize(item.dataset.typeHandle || '');

      if (typeFilter && itemType !== typeFilter) {
        visible = false;
      }

      if (visible && enableValidity) {
        var deliveryDate = item.getAttribute('data-delivery-date');
        if (deliveryDate) {
          var delivery = parseLocalDate(deliveryDate);
          if (delivery) {
            var expiry = new Date(delivery.getTime());
            expiry.setDate(expiry.getDate() + validityDays);
            if (today.getTime() > expiry.getTime()) {
              visible = false;
            }
          }
        }
      }

      item.hidden = !visible;
      item.style.display = visible ? '' : 'none';

      if (visible) visibleCount += 1;
    });

    root.querySelectorAll('.metaobject-type-filter').forEach(function (link) {
      var linkType = handleize(link.dataset.typeFilter || '');
      var isActive = linkType === typeFilter;
      link.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    var emptyMessage = root.querySelector('.metaobject-filter-empty-message');
    if (emptyMessage) {
      emptyMessage.classList.toggle('hidden', visibleCount > 0);
    }
  }

  document.querySelectorAll('[data-metaobject-filter-root]').forEach(applyMetaobjectFilters);
})();

  } catch(e) { console.error(e); }
})();
})();
